import { render, staticRenderFns } from "./pendingphotos.vue?vue&type=template&id=49ad4230"
import script from "./pendingphotos.vue?vue&type=script&lang=js"
export * from "./pendingphotos.vue?vue&type=script&lang=js"
import style0 from "./pendingphotos.vue?vue&type=style&index=0&id=49ad4230&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports